import {
  OuterMeasurementsComponent,
  Part,
  Product,
  ProductType
} from '@inter-ikea-storageone/range';
import {
  ProhibitAdjustableComponent,
  RequestUprightsComponent
} from '@inter-ikea-storageone/range-boaxel';
import { BehaviorParameters } from 'rangeConfig/@types';
import { getMarketProducts } from 'ducks/products';

const getNonMountingRail = (mountingRailPart: Part, products: Product[]) => {
  const mountingRail = products.find(
    p => p.type === ProductType.BOAXEL_MOUNTING_RAIL && p.coreProductId === mountingRailPart.id
  );

  if (!mountingRail)
    throw new Error(`Could not find mounting rail product ${mountingRailPart.id}.`);

  const nonMountingRail = products.find(
    p => p.type === ProductType.BOAXEL_NON_MOUNTING_RAIL && p.design === mountingRail.design
  );

  if (!nonMountingRail)
    throw new Error(`Could not find matching non-mounting rail for ${mountingRailPart.id}.`);

  return nonMountingRail;
};

const getUprightProductOfSection = (section: Product, products: Product[]) => {
  const upright = products.find(
    p => p.type === ProductType.BOAXEL_UPRIGHT && p.coreProductId === section.meta?.relatedArticle
  );
  if (!upright)
    throw new Error(`Could not find upright product of section ${section.coreProductId}.`);

  return upright;
};

export const addSection = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const productsInMarket = getMarketProducts(rootState);
  const adjustableProducts = productsInMarket.filter(
    p =>
      p.communicatedDimensions.width < 600 &&
      [ProductType.BOAXEL_ADJ_SHELF, ProductType.BOAXEL_ADJ_CLOTHES_RAIL].includes(p.type)
  );

  const addedProduct = productsInMarket.find(p => p.coreProductId === props.coreProductId);

  if (!addedProduct) throw new Error('Could not find added product');

  const { type, coreProductId, parts } = addedProduct;

  const uprightId =
    type === ProductType.BOAXEL_UPRIGHT_SECTION
      ? getUprightProductOfSection(addedProduct, productsInMarket).coreProductId
      : coreProductId;

  const nonMountingRailId = getNonMountingRail(parts[2], productsInMarket).coreProductId;
  const uprightLeft = coreApi.entities.create(uprightId);
  const uprightRight = coreApi.entities.create(uprightId);
  const nonMountingRail = coreApi.entities.create(nonMountingRailId);

  if (!uprightLeft || !uprightRight || !nonMountingRail) return;

  const width = addedProduct.communicatedDimensions.width;
  const uprights = { uprightLeft, uprightRight };

  if (!adjustableProducts.length) {
    // If no adjustable products are sold on the market we add a component
    // checked against in validation to prevent resizing to adjustable widths.
    nonMountingRail.addComponent(new ProhibitAdjustableComponent());
  }
  nonMountingRail.addComponent(new OuterMeasurementsComponent());
  nonMountingRail.addComponent(new RequestUprightsComponent(uprights, width, props.position));
};
